import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TauxReconnaissance } from 'src/app/shared/models/tauxReconnaissance';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TauxReconnaissanceModalAjoutComponent } from '../modal/tauxReconnaissance-modal-ajout/tauxReconnaissance-modal-ajout.component';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { TauxReconnaissanceModalDetailComponent } from '../modal/tauxReconnaissance-modal-detail/tauxReconnaissance-modal-detail.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-tauxReconnaissance',
	templateUrl: './list-tauxReconnaissance.component.html',
	styleUrls: ['./list-tauxReconnaissance.component.scss']
})
export class ListTauxReconnaissanceComponent implements OnInit {
	tauxReconnaissance: TauxReconnaissance[] = [];
	currentPage = 1;
	itemsPerPage = 10;

	tauxReconnaissanceCsvFile: File = null;
	searchedSkill = '';
	searchedName = '';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	sortType = 'firstName';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	editTauxReconnaissanceModalRef: BsModalRef;
	addTauxReconnaissanceModalRef: BsModalRef;
	screenWidth: number;
	isMobile: boolean = false;

	isListingLoading: boolean = true;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getTauxReconnaissance();
		this.isAddable = true;
	}

	getTauxReconnaissance(): void {
		this.isListingLoading = true;
		this.facade.tauxReconnaissanceService.getAllTauxReconnaissance().subscribe({
			next: (val) => {
				this.tauxReconnaissance = val.filter((e) => e.name !== 'Sans');
				this.itemsPerPage = this.tauxReconnaissance.length >= 8 ? 10 : 8;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
				this.tauxReconnaissance = [];
			}
		});
	}

	selectTauxReconnaissance(tauxReconnaissance: TauxReconnaissance): void {
		const link = ['/tauxReconnaissance', tauxReconnaissance.id];
		this.router.navigate(link);
	}

	importTauxReconnaissance(event: any): void {
		this.tauxReconnaissanceCsvFile = event.target.files[0];

		this.facade.tauxReconnaissanceService
			.importTauxReconnaissance(this.tauxReconnaissanceCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.alerts.push({
						type: 'success',
						msg: `${importStats.entitiesAdded} tauxReconnaissance ont été ajoutés,
                  ${importStats.entitiesBeforeImport} étaient déjà présents.`
					});

					this.getTauxReconnaissance();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		this.addTauxReconnaissanceModalRef = this.modalService.show(
			TauxReconnaissanceModalAjoutComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addTauxReconnaissanceModalRef.onHide.subscribe((reason: string | any) => {
			this.getTauxReconnaissance();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(tauxReconnaissance: TauxReconnaissance) {
		const initialState = {
			tauxReconnaissance: tauxReconnaissance
		};
		this.editTauxReconnaissanceModalRef = this.modalService.show(
			TauxReconnaissanceModalDetailComponent,
			{
				class: '',
				initialState
			}
		);

		this.editTauxReconnaissanceModalRef.onHide.subscribe((reason: string | any) => {
			this.getTauxReconnaissance();
		});
	}
}
